import React from 'react';
import { useDisclosure, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody } from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import logo from '../../../src/Images/navLogo.png';
import './MindProbe_Home.css';

const Header = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <div id='mindprobe_home'>
            <div id='main'>
                <div id='main_nav_container'>
                    <div id='main_nav_logo'>
                        <img src={logo} alt="logo" />
                    </div>
                    <div id='main_nav_links'>
                        <a href='/'>Home</a>
                        <a href='/history'>History</a>
                        <a href='/achievements'>Achievements</a>
                        <a href='/projects'>Projects</a>
                        <a href='/squad'>Squad</a>
                        <a href='/mindprobe'><b>MindProbe</b></a>
                        <HamburgerIcon onClick={onOpen} id='hamburgerIcon' />
                    </div>
                </div>
                <div id='container'>
                    <div id='nav'>
                        <img id='logo_nav' src='/mp25.png' alt='MindProbe Logo'></img>
                        <a href='#mindprobe_home'>HOME</a>
                        <a href='#mindprobe_about'>ABOUT</a>
                        <a href='#mindprobe_contact'>CONTACT</a>
                    </div>
                    <div id='line'></div>
                    <div id='content'>
                        <div id='logo_container'>
                            <img id='logo_main' src="/mp25.png" alt='MindProbe Logo'></img>
                            <img id='logo_stroke' src='/mp25_out.png' alt='MindProbe Logo Outline'></img>
                        </div>
                        <div id='home_text_container'>
                            <p>THE ULTIMATE ODYSSEY FOR UNIQUE EXCELLENCE</p>
                            <p>THE LARGEST QUIZ DAY ORGANIZED BY A SCHOOL IN SRI LANKA</p><br />
                        </div>
                        <div id='button_container'>
                            <a href='#mindprobe_register' id='button_register'>REGISTER NOW</a>
                            <a
                                href="https://drive.google.com/file/d/14PWkikiGxPpR-meAHJ_VNVkbD4mIvOT0/view?usp=drivesdk"
                                id="button_rr"
                                className="button_register_style"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                RULES & REGULATIONS
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <Drawer placement='top' onClose={onClose} isOpen={isOpen}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerHeader borderBottomWidth="1px">
                        <div id='mindprobe_mobile_nav_header'>
                            <img src={logo} alt="logo" />
                            <CloseIcon onClick={onClose} id='hamburgerIcon' />
                        </div>
                    </DrawerHeader>
                    <DrawerBody id='mindprobe_mobile_nav_items_container'>
                        <a href='/'>Home</a><br />
                        <a href='/history'>History</a><br />
                        <a href='/achievements'>Achievements</a><br />
                        <a href='/projects'>Projects</a><br />
                        <a href='/squad'>Squad</a><br />
                        <div id='mindprobe_mobile_nav_items'>
                            <a href='/mindprobe' id='current'><b>MindProbe</b></a><br />
                            <a href='#mindprobe_home' onClick={onClose}>Home</a><br />
                            <a href='#mindprobe_about' onClick={onClose}>About</a><br />
                            <a href='#mindprobe_contact' onClick={onClose}>Contact</a><br />
                        </div>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </div>
    )
}

export default Header
